import { gql } from '@apollo/client';
/**
 * @const ExportDealsMutation
 * @since 1.0.0
 */
export const ExportDealsMutation = gql `
  mutation ExportSaleAgreementsMutation($input: ExportDealsInput!) {
    exportDeals(input: $input)
  }
`;
